import { Components, Theme } from '@mui/material/styles';

export const MuiDateCalendar: Components<Theme>['MuiDateCalendar'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      width: theme.spacing(320),
      maxHeight: theme.spacing(336),
      height: theme.spacing(336),
    }),
  },
};
